import { Modal, Typography } from "antd";
import "./confirm-integration-modal.scss";

interface ConfirmIntegrationModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  cardTitle?: string;
}

export const ConfirmIntegrationModal = ({
  open,
  onConfirm,
  onCancel,
  cardTitle,
}: ConfirmIntegrationModalProps) => {
  return (
    <Modal
      open={open}
      title="Изменение настроек интеграции"
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Сохранить"
      cancelText="Отмена"
      okButtonProps={{ type: "primary" }}
      width={480}
    >
      <div className="confirm-integration-modal__content">
        <Typography.Text>
          Вы уверены, что хотите изменить настройки интеграции
          {cardTitle && ` для "${cardTitle}"`}?
        </Typography.Text>
      </div>
    </Modal>
  );
};

